import apiClient from '../config/api';

const machineService = {
  /**
   * Get all machines for the current tenant
   * @param {number} lineId - Optional line ID to filter machines
   * @returns {Promise} Array of machines
   */
  getAllMachines: async (lineId = null) => {
    const params = lineId ? { lineId } : {};
    const response = await apiClient.get('/machine', { params });
    return response.data;
  },

  /**
   * Alias for backward compatibility; tenantId is ignored because the API uses token scope.
   * @param {number} tenantId - Optional tenantId (unused)
   * @returns {Promise} Array of machines
   */
  getMachines: async (_tenantId = null) => {
    return machineService.getAllMachines();
  },

  /**
   * Get machine by ID
   * @param {number} machineId - Machine ID
   * @returns {Promise} Machine details
   */
  getMachineById: async (machineId) => {
    const response = await apiClient.get(`/machine/${machineId}`);
    return response.data;
  },

  /**
   * Create a new machine
   * @param {object} machineData - Machine data
   * @returns {Promise} Created machine
   */
  createMachine: async (machineData) => {
    const response = await apiClient.post('/machine', machineData);
    return response.data;
  },

  /**
   * Update machine
   * @param {number} machineId - Machine ID
   * @param {object} machineData - Updated machine data
   * @returns {Promise} Updated machine
   */
  updateMachine: async (machineId, machineData) => {
    const response = await apiClient.post(`/machine/update/${machineId}`, machineData);
    return response.data;
  },

  /**
   * Delete machine
   * @param {number} machineId - Machine ID
   * @returns {Promise} Deletion result
   */
  deleteMachine: async (machineId) => {
    const response = await apiClient.post(`/machine/delete/${machineId}`);
    return response.data;
  },
};

export default machineService;

